import { api } from 'shared/api';
import { RoleViewModel } from 'shared/types';

export interface FetchRolesResponse {
    items: RoleViewModel[];
    totalItems: number;
    matchedItems: number;
    highlights: string[];
}

export const searchRoles = async (
    searchString: string,
    pageNum = 1,
    pageSize = 20,
    signal?: AbortSignal
) => {
    const params = new URLSearchParams({
        searchString,
        pageNum: pageNum.toString(),
        pageSize: pageSize.toString()
    });

    return await api.get<FetchRolesResponse>(
        `/References/SearchRoles?${ params.toString() }`,
        undefined,
        { signal }
    );
};
